import {h, Fragment} from "preact"
import { useAppState, AutocompleteElement } from '@nosto/preact'
import AutocompleteProduct from './Product'
import { defaultConfig } from '../config'
import { formatCurrency } from '../helpers'
import { useEffect, useState } from 'preact/hooks'
import useArticlesBlogs from '../serp/useArticlesBlogs'

export default () => {
    const { response: { query, products, keywords } } = useAppState();
    if (!products?.hits?.length && !keywords?.hits?.length) return    
    const { dropdownArticlesBlogs } = useArticlesBlogs();

    const handleClose = () => {
        document.querySelector('.header__icon-wrapper[aria-label="Search"]')?.click();
    }

    useEffect(() => {
        const handleKeydown = (event) => {
            if(event.key === 'Enter') {
                handleClose();
            }
        }
        document.getElementById('nosto-search-input').addEventListener('keydown', handleKeydown);
        return () => document.getElementById('nosto-search-input').removeEventListener('keydown', handleKeydown);
    }, [])

    useEffect(() => {
        if(window.StampedFn?.reloadUGC) {
            window.StampedFn.reloadUGC();
        }
    }, [products])

    return (
        <div data-nosto-element="autocomplete" class="ns-autocomplete">
            <div class="ns-autocomplete-body">
                {(keywords?.hits?.length > 0 || dropdownArticlesBlogs?.length > 0) &&
                <div class="ns-keywords">
                    {keywords?.hits?.length > 0 && 
                        <div>
                            <p class="ns-autocomplete-section-header">Related Searches</p>
                            <div class="ns-keywords-container">
                                <ul>
                                    {keywords?.hits?.map((hit) => {
                                        if(hit.keyword.includes(' 10.00')) return
                                        return <li  onClick={handleClose} class="ns-clickable">
                                            <AutocompleteElement hit={hit}>
                                                {hit?._highlight?.keyword
                                                    ? <span  class="ns-clickable" dangerouslySetInnerHTML={{ __html: hit._highlight.keyword}}></span>
                                                    : <span  class="ns-clickable">{hit.keyword}</span>
                                                }
                                            </AutocompleteElement>
                                        </li>
                                    })}
                                </ul>
                            </div>
                        </div>
                    }
                    {dropdownArticlesBlogs?.length > 0 &&
                        <div class="ns-autocomplete-articles">
                            <p class="ns-autocomplete-section-header">Articles &amp; Blogs</p>
                            <div class="ns-keywords-container">
                                <ul>
                                    {dropdownArticlesBlogs.slice(0, defaultConfig.articlesSize).map((item) => (
                                        <li>
                                            <a href={item.url}>{item.title}</a>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    }
                </div>}
                <div class="ns-autocomplete-products">
                    <div class="ns-autocomplete-section-header">
                        <p>Products</p>
                        <button type="submit" class="ns-viewall-desktop-toggle link-bar__link link--animated " title="show search results" onClick={handleClose}>
                            View All {products.total} Results
                            <svg focusable="false" width="12" height="13" class="icon icon--nav-arrow-right  icon--direction-aware " viewBox="0 0 17 14" style="display: block;">
                                <path d="M0 7h15M9 1l6 6-6 6" stroke="currentColor" stroke-width="1.2" fill="none"></path>
                            </svg>
                        </button>
                    </div>
                    <div class="ns-autocomplete-products-container">
                        {products?.hits?.slice(0, 4).map((hit) => (
                            <AutocompleteProduct product={hit} />
                        ))}
                        <button type="submit" class="ns-viewall-mobile-toggle link link-bar__link link--animated " title="show search results" onClick={handleClose}>
                            View All {products.total} Results
                            <svg focusable="false" width="12" height="13" class="icon icon--nav-arrow-right  icon--direction-aware " viewBox="0 0 17 14" style="display: block;">
                                <path d="M0 7h15M9 1l6 6-6 6" stroke="currentColor" stroke-width="1.2" fill="none"></path>
                            </svg>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}
